import React from "react";
import { CircularProgress } from "@mui/material";
import clsx from "clsx";

export interface TextValueProps {
  title: string | number | React.ReactNode;
  value: string | number | React.ReactNode;
  className?: any;
  isLoading?: boolean;
}

export function TextValue({
  className,
  value,
  title,
  isLoading,
}: TextValueProps) {
  return (
    <div className={clsx("w-full flex justify-between items-start", className)}>
      <div className="text-sm text-gray-110 flex justify-center items-center">
        {title}:
      </div>
      <div className="text-sm text-gray-130 font-bold flex justify-center items-center text-left">
        {isLoading ? <CircularProgress size={16} /> : <>{value && value}</>}
      </div>
    </div>
  );
}

export default TextValue;
